export class ProbeError {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "code",
            "baseName": "code",
            "type": "ProbeErrorCode",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "hint",
            "baseName": "hint",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ProbeError.attributeTypeMap;
    }
    constructor() {
    }
}
